import React from 'react';
import { Outlet } from 'react-router-dom';

const CRMLayout = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950">
      <main className="p-6">
        <Outlet />
      </main>
    </div>
  );
};

export default CRMLayout; 